// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-list-container{padding:16px}.user-list-container .user-list{background-color:#fff;border-radius:5px;padding:16px}.detail-user .ant-form-item{width:100%;max-width:700px;margin-bottom:20px !important}.detail-user .ant-form-item select[name$='-country']{min-height:35px;border:1px solid #e0e0e0;width:100%;border-radius:5px;padding:0 5px 0 5px}\n", ""]);
// Exports
module.exports = exports;
